import { useContext } from 'react';
import { ThemeContext } from 'styled-components/native';

export const useTheme = () => {
  const theme = useContext(ThemeContext);
  return theme || {};
}
